import {useSummerTShirtPromoTest} from './constants/signalmanConstants';

export const SUMMER_DISCOUNT_CATEGORY_IDS = [
  16, 17, 18, 20, 60, 83, 84, 104, 109, 110, 113, 124, 247, 399, 434, 435, 451,
  460, 505, 514, 607
];

export const SUMMER_DISCOUNT_STYLE_IDS = [
  2283900, 2123100, 1882100, 2121900, 1882200, 1790000, 1789900, 1789800,
  1632900, 1632700, 1520200, 1520100, 1520000, 1195500, 174000, 180800, 245500,
  250100, 255100, 300300, 301600, 301800, 659300, 820300, 923500, 923600,
  1018500, 1052800, 1081400, 1081500, 1092300, 1154600, 1182400, 1510300,
  1513000, 1513100, 1516700, 1518000, 1536800, 1595900, 1596600, 1781600,
  1781700, 2060500, 2066100, 2099600, 2099700, 290000, 303800, 336200, 342700,
  352900, 392600, 214300, 290300, 299300, 304200, 305000, 353200, 361900,
  362000, 651400, 794000, 211200, 2285200, 2281200, 1186100, 1535700, 1536100,
  158300, 163900, 184700, 185300, 206700, 211100, 213800, 240900, 269100,
  406900, 407100, 575800, 645700, 794100, 794200, 796000, 1125500, 1158600,
  1514500, 1514600, 1534200, 2089500, 2089700, 2089800, 140400, 183500, 202300,
  207700, 1121600, 1126300, 182900, 197500, 197600, 207600, 406500, 576000,
  970600, 1121500, 1124800, 1125700
];

export function isTshirtSummerPromoEligible(isSiteWideSearch, categoryId) {
  return (
    !isSiteWideSearch &&
    SUMMER_DISCOUNT_CATEGORY_IDS.includes(Number(categoryId))
  );
}

export function isTshirtSummerPromoEligibleForProduct(
  primaryCategoryId,
  styleId
) {
  return (
    SUMMER_DISCOUNT_CATEGORY_IDS.includes(Number(primaryCategoryId)) ||
    SUMMER_DISCOUNT_STYLE_IDS.includes(Number(styleId))
  );
}

export function useTshirtSummerPromo({categoryId, isSiteWideSearch}) {
  const {
    error: isSummerTShirtPromoTestError,
    isLoading: isSummerTShirtPromoTestLoading,
    variation: summerTShirtPromoTestVariation
  } = useSummerTShirtPromoTest();

  const tshirtSummerPromoEligible = isTshirtSummerPromoEligible(
    isSiteWideSearch,
    categoryId
  );

  const isEnabled =
    !isSummerTShirtPromoTestError && summerTShirtPromoTestVariation === 'test';

  return {
    isEligible: tshirtSummerPromoEligible,
    isEnabled,
    isLoading: isSummerTShirtPromoTestLoading
  };
}

export function useTshirtSummerPromoForProduct({primaryCategoryId, styleId}) {
  const {
    error: isSummerTShirtPromoTestError,
    isLoading: isSummerTShirtPromoTestLoading,
    variation: summerTShirtPromoTestVariation
  } = useSummerTShirtPromoTest();

  const tshirtSummerPromoEligible = isTshirtSummerPromoEligibleForProduct(
    primaryCategoryId,
    styleId
  );

  const isEnabled =
    !isSummerTShirtPromoTestError && summerTShirtPromoTestVariation === 'test';

  return {
    isEligible: tshirtSummerPromoEligible,
    isEnabled,
    isLoading: isSummerTShirtPromoTestLoading
  };
}
